import { createReducer, on } from '@ngrx/store';

import * as templateActions from '../actions/templates.actions';
import { TemplateData } from '../../interfaces/templates.model';

export const templatesFeatureKey = 'templates';

export interface TemplateState {
  entities: Array<TemplateData>;
  allTemplates: Array<TemplateData>;
  loaded: boolean;
  loading: boolean;
  allLoaded: boolean;
  allLoading: boolean;
  total: number;
  importing: boolean;
  imported: boolean;
}

export const initialState:TemplateState = {
  entities: [],
  allTemplates: [],
  loaded: false,
  loading: false,
  allLoaded: false,
  allLoading: false,
  total: 0,
  importing: false,
  imported: false
};

const templatesReducer = createReducer(
  initialState,
  on(templateActions.loadTemplates, state => ({ ...state, loading: true })),
  on(templateActions.loadTemplatesSuccess, (state, { payload }) => {
    const templates = payload;
    const total = templates.total || templates.results.length;
    const entities = templates.results.reduce((all: { [uid: string]: TemplateData }, item: TemplateData) => {
      return { ...all, [item.uid]: item };
    }, {});
    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(templateActions.loadTemplatesFail, state => ({ ...state, loading: false, loaded: false })),
  on(templateActions.loadMoreTemplates, state => ({ ...state, loading: true })),
  on(templateActions.loadMoreTemplatesSuccess, (state, { payload }) => {
    const templates = { ...payload, results: [...payload?.results, ...Object.values(state.entities)] };
    const total = templates.total || templates.results.length;

    const entities = templates.results.reduce((all: { [uid: string]: TemplateData }, item: TemplateData) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(templateActions.loadMoreTemplatesFail, state => ({ ...state, loading: false, loaded: false })),
  on(templateActions.loadAllTemplates, state => ({ ...state, AllLoading: true })),
  on(templateActions.loadAllTemplatesSuccess, (state, { payload }) => {
    const allTemplates = payload;

    return { ...state, allLoading: false, allLoaded: true, allTemplates };
  }),
  on(templateActions.loadAllTemplatesFail, state => ({ ...state, allLoading: false, allLoaded: false })),
  on(templateActions.searchTemplates, state => ({ ...state, loading: true })),
  on(templateActions.searchTemplatesSuccess, (state, { payload }) => {
    const entities = payload;
    return { ...state, loading: false, loaded: true, entities };
  }),
  on(templateActions.searchTemplatesFail, state => ({ ...state, loading: false, loaded: false }))
);

export function reducer(state, action) {
  return templatesReducer(state, action);
}

export const getTemplatesEntities = (state: TemplateState) => state?.entities;
export const getTemplatesLoading = (state: TemplateState) => state?.loading;
export const getTemplatesLoaded = (state: TemplateState) => state?.loaded;
export const getTotalTemplates = (state: TemplateState) => state?.total;

export const getAllTemplatesEntities = (state: TemplateState) => state?.allTemplates;
export const getAllTemplatesLoading = (state: TemplateState) => state?.allLoading;
export const getAllTemplatesLoaded = (state: TemplateState) => state?.allLoaded;
